module.exports = __webpack_public_path__ + "media/18.6e03ef10.mp3";